/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import Lista_Tarjeta_Valores_Home from "./SubComponentes/Lista_Tarjeta_Valores_Home";
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import fondo from '../../../Recursos/fondo_valores.png'

const Valores_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
            sx={{
                background: `linear-gradient(90deg,rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.75) 100%), url(${fondo})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                py: 20,
            }}>

            <Grid2 container size={11} justifyContent={'center'}
                   sx={{maxWidth: "1400px", px: 3, position: 'relative'}}>

                <Grid2 container size={12} justifyContent={'center'}>
                    <Typography
                        sx={{
                            fontSize: sCell ? 24 : 32,
                            color: 'white',
                            px: sCell ? 4 : 14,
                            py: 1,
                            borderRadius: 10,
                            backgroundColor: theme.palette.primary.main,
                            position: sCell ? 'relative' : 'absolute',
                            top: sCell ? -189 : -194,
                            fontWeight: 600,
                            textAlign: sCell ? 'center' : 'left'
                        }}>
                        Servicios prestados
                    </Typography>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? -11 : 0}}>

                    <Lista_Tarjeta_Valores_Home/>

                </Grid2>


            </Grid2>

        </Grid2>
    )

}
export default Valores_Home